import React from 'react';
import AuthUserContext from '../../components/Session/context';
import FormNavConfirm from '../../components/form/FormNavConfirm';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Divider from '@material-ui/core/Divider';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
// import Switch from '@material-ui/core/Switch';
// import Chip from '@material-ui/core/Chip';
// import TextField from '@material-ui/core/TextField';

// import Radio from '@material-ui/core/Radio';
// import RadioGroup from '@material-ui/core/RadioGroup';
// import FormControlLabel from '@material-ui/core/FormControlLabel';
import { RoundedInput } from '../../components/form';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';

import { withStyles } from '@material-ui/core/styles';
import { withFirebase } from '../../components/Firebase';
import { withRouter } from 'react-router-dom';

import { compose } from 'recompose';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faTrash, faFileImage } from '@fortawesome/free-solid-svg-icons';
import { openConfirmDialog } from '../../components/Dialog';
import { AsyncCountrySelect } from '../../components/form';
import Utilities, { nullifyIds, initField } from '../../utils/utilities';
import { openSnackbar } from '../../components/Notifier';
import * as ROLES from '../../constants/roles';
import { cloneDeep } from 'lodash';

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    display: 'flex',
    flexWrap: 'wrap',
    padding: '12px',
  },
  paper: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    backgroundColor: theme.palette.grey[50],
    borderRadius: theme.spacing(1),
  },
  leftIcon: {
    marginRight: theme.spacing(1),
  },
  roundedButton: {
    borderRadius: '100px',
    marginRight: theme.spacing(2.5),
  },
  deleteButton: {
    backgroundColor: theme.palette.common.danger,
  },
  divider: {
    width: `calc(100% + ${theme.spacing(4)}px)`,
    marginLeft: `-${theme.spacing(2)}px`,
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  bottomMargin: {
    marginBottom: theme.spacing(4),
  },
  avatar: {
    width: 110,
    // height: 110,
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  marginYZero: {
    marginTop: '0px;',
    marginBottom: '0px;',
  },
});

class UserForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.maxFileMb = 5;
  }

  componentDidMount() {
    let { user } = this.props;
    this.checkFreightForwarderId(user);
    let previewUrl;
    previewUrl = Utilities.getPhotoUrl(user.profile_images, 'avatar');
    this.setState({
      previewUrl,
      user,
      pristineUser: cloneDeep(user),
    });
    this.getFreightForwarders();
  }

  checkFreightForwarderId = (user) => {
    initField(user, 'roles', []);
    ['code', 'name', 'email', 'title', 'phone', 'ddi'].forEach((field) => initField(user, field, ''));
    if (user.roles.includes(ROLES.ADMIN)) {
      user.freight_forwarder_id = null;
    } else if (user.freight_forwarder_id == null) {
      user.freight_forwarder_id = '';
    }
  };

  getFreightForwarders = () => {
    if (this.props.lock_freight_forwarder === undefined) {
      return this.props.firebase
        .getAllRecursive('freightForwarders')
        .then((freightForwarders) => this.setState({ freightForwarders }));
    }
  };

  handleInputChange = (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    this.setState((state) => {
      let user = state.user;
      user[name] = value;
      if (name === 'roles') {
        user[name] = [value]; //it is store in an array in the DB
        this.checkFreightForwarderId(user);
      }
      return { user };
    });
  };

  handleFileInputChange = (event) => {
    const target = event.target;
    this.setState((state) => {
      let user = state.user;
      let { previewUrl } = state;
      if (target.files && target.files.length > 0) {
        let sizeMb = (target.files[0].size / (1024 * 1024)).toFixed(2);
        if (sizeMb > this.maxFileMb) {
          openSnackbar({
            message: `File cannot be larger than: ${this.maxFileMb}MB. Current file is ${sizeMb}MB`,
            variant: 'error',
          });
        } else {
          user.profile_images = target.files[0];
          previewUrl = URL.createObjectURL(target.files[0]);
        }
      }
      return {
        user,
        previewUrl,
      };
    });
  };

  goBack = () => {
    this.setState({ pristineUser: cloneDeep(this.state.user) }, () => this.props.history.goBack());
  };

  submit = () => {
    this.setState({ pristineUser: cloneDeep(this.state.user) }, () => {
      this.props.onSubmit(nullifyIds(this.state.user, ['freight_forwarder_id']));
    });
  };

  delete = () => {
    let { user } = this.state;
    openConfirmDialog({
      title: 'Confirm Delete',
      message: `Are you sure you want to delete user: ${user.name}?`,
    }).then((res) => {
      if (res === 'OK') {
        this.props.onDelete(user);
      }
    });
  };

  render() {
    const { classes, lock_freight_forwarder } = this.props;
    const { user, freightForwarders, pristineUser, previewUrl } = this.state;
    const { constants } = this.context.authUser;
    const { roles } = constants;

    return user ? (
      <Paper className={`${classes.paper} ${classes.root}`}>
        <FormNavConfirm formObject={user} pristineObject={pristineUser} />
        <Grid container spacing={3}>
          <Grid item xs={4}>
            <FormControl fullWidth>
              <InputLabel shrink={true} htmlFor="name">
                Name
              </InputLabel>
              <RoundedInput
                value={user.name}
                name="name"
                placeholder="Enter Name"
                onChange={this.handleInputChange}
                required
              />
            </FormControl>
          </Grid>
          <Grid item xs={4}>
            <FormControl fullWidth>
              <InputLabel shrink={true} htmlFor="select-roles">
                Roles
              </InputLabel>
              {/* prettier-ignore */}
              <Select
                                value={user.roles}
                                onChange={this.handleInputChange}
                                input={<RoundedInput id="select-roles" name="roles" />}
                            >
                                {roles.map((role) => (
                                    <MenuItem key={role.code} value={role.code}>
                                        {`${role.code} - ${role.description}`}
                                    </MenuItem>
                                ))}
                            </Select>
            </FormControl>
          </Grid>
          <Grid item xs={4}>
            {!user.roles.includes(ROLES.ADMIN) && lock_freight_forwarder !== true && (
              <FormControl fullWidth>
                <InputLabel shrink={true} htmlFor="freight_forwarder_id">
                  Freight Forwarder
                </InputLabel>
                {/* prettier-ignore */}
                <Select
                                    variant="outlined"
                                    value={user.freight_forwarder_id}
                                    onChange={this.handleInputChange}
                                    input={<RoundedInput name="freight_forwarder_id"
                                />}>
                                    {freightForwarders &&
                                        freightForwarders.map((freight_forwarder) => {
                                            return (
                                                <MenuItem key={freight_forwarder._id} value={freight_forwarder._id}>
                                                    {freight_forwarder.name}
                                                </MenuItem>
                                            );
                                        })}
                                </Select>
              </FormControl>
            )}
          </Grid>
          <Grid item xs={4}>
            <FormControl fullWidth>
              <InputLabel shrink={true} htmlFor="email">
                Email
              </InputLabel>
              <RoundedInput
                value={user.email}
                name="email"
                type="email"
                placeholder="Email"
                onChange={this.handleInputChange}
                required
              />
            </FormControl>
          </Grid>
          <Grid item xs={4}>
            <FormControl fullWidth>
              <InputLabel shrink={true} htmlFor="email">
                Home Country
              </InputLabel>
              <AsyncCountrySelect
                value={user.home_country_code}
                onChange={this.handleInputChange}
                countryField="code"
                name="home_country_code"
                className="MuiInput-formControl"
              ></AsyncCountrySelect>
            </FormControl>
          </Grid>
        </Grid>
        <Grid container spacing={3}>
          <Grid item xs={4}>
            <FormControl fullWidth>
              <InputLabel shrink={true}>Clients</InputLabel>
              <RoundedInput value={user.clients && user.clients.map((c) => c.name).join(', ')} disabled={true} />
            </FormControl>
          </Grid>
          <Grid item xs={4}>
            <FormControl fullWidth>
              <InputLabel shrink={true}>Code</InputLabel>
              <RoundedInput
                value={user.code}
                name="code"
                type="text"
                placeholder="Optional"
                onChange={this.handleInputChange}
              />
            </FormControl>
          </Grid>
        </Grid>
        <Divider className={classes.divider} />
        <Grid container spacing={3} className={classes.bottomMargin}>
          <Grid item xs={4}>
            <Typography variant="subtitle2" gutterBottom>
              Photo (may appear on communications with clients)
            </Typography>
            <input
              accept="image/*"
              style={{ display: 'none' }}
              id="raised-button-file"
              type="file"
              onChange={this.handleFileInputChange}
            />
            <label htmlFor="raised-button-file">
              <Button variant="contained" component="span">
                {previewUrl && previewUrl.length > 0 ? (
                  <img alt={user.name} src={previewUrl} className={classes.avatar} />
                ) : (
                  <FontAwesomeIcon icon={faFileImage} size="6x" />
                )}
              </Button>
            </label>
            <Typography variant="body1">File must be an image less than {this.maxFileMb}MB.</Typography>
          </Grid>
          <Grid item xs={4}>
            <FormControl fullWidth>
              <InputLabel shrink={true} htmlFor="title">
                Title/role (may appear on communications with clients)
              </InputLabel>
              <RoundedInput
                type="email"
                value={user.title}
                name="title"
                placeholder="Enter title"
                onChange={this.handleInputChange}
                required
              />
            </FormControl>
          </Grid>
          <Grid item xs={4}>
            <FormControl fullWidth>
              <InputLabel shrink={true} htmlFor="phone">
                Mobile (may appear on communications with clients)
              </InputLabel>
              <RoundedInput
                value={user.phone}
                name="phone"
                placeholder="Enter phone"
                onChange={this.handleInputChange}
                required
              />
            </FormControl>
            <FormControl fullWidth>
              <InputLabel shrink={true} htmlFor="ddi">
                DDI (may appear on communications with clients)
              </InputLabel>
              <RoundedInput
                value={user.ddi}
                name="ddi"
                placeholder="Enter Direct Dial In Number"
                onChange={this.handleInputChange}
              />
            </FormControl>
          </Grid>
        </Grid>
        <Divider className={classes.divider} />
        <Grid container spacing={3} className={classes.bottomMargin}>
          <Grid item xs={6}>
            {user._id && (
              <Button
                onClick={this.delete}
                size="large"
                variant="contained"
                color="primary"
                className={`${classes.roundedButton} ${classes.deleteButton}`}
              >
                <FontAwesomeIcon className={classes.leftIcon} icon={faTrash} />
                Delete
              </Button>
            )}
          </Grid>
          <Grid item xs={6}>
            <Grid container className={classes.marginYZero} spacing={3} justifyContent="flex-end">
              <Button
                onClick={this.goBack}
                size="large"
                variant="outlined"
                color="primary"
                className={classes.roundedButton}
              >
                Cancel
              </Button>
              <Button
                onClick={this.submit}
                size="large"
                variant="contained"
                color="primary"
                className={classes.roundedButton}
              >
                <FontAwesomeIcon className={classes.leftIcon} icon={faPlus} />
                {this.props.submitButtonText}
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Paper>
    ) : null;
  }
}

UserForm.contextType = AuthUserContext;

UserForm.propTypes = {
  classes: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
  submitButtonText: PropTypes.string.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

export default compose(withStyles(styles, { withTheme: true }), withFirebase, withRouter)(UserForm);
